/**
 * LandingSLKflowLandingRoute
 *
 * Page component for LandingSLKflowLandingRoute
 * Path: /sl
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { LandingSLKflowLandingPageView as __LandingSLKflowLandingPageView } from '@/components/traits/LandingSLKflowLandingPageView';
import { LandingSLKflowLandingAnalyticsView as __LandingSLKflowLandingAnalyticsView } from '@/components/traits/LandingSLKflowLandingAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { SharedEntityStoreContext, useSharedEntityStore, usePageHead } from '@almadar/ui/hooks';
import { ModalSlot } from '@almadar/ui/components';

interface LandingSLKflowLandingRouteProps {
  // Add any page-level props here
}

export function LandingSLKflowLandingRoute(_props: LandingSLKflowLandingRouteProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","kflow-landing:meta.title"],"description":["i18n/t","kflow-landing:meta.description"],"access":"public","indexing":"index","origin":"https://kflow.academy","siteName":"KFlow","alternates":[{"locale":"en","path":"/"},{"locale":"ar","path":"/ar"},{"locale":"sl","path":"/sl"}],"defaultLocale":"en", path: __location.pathname });

  const _sharedStore = useSharedEntityStore();

  return (
    <SharedEntityStoreContext.Provider value={_sharedStore}>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__LandingSLKflowLandingPageView config={{ initPayload: __navState }} />
          <__LandingSLKflowLandingAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </SharedEntityStoreContext.Provider>
  );
}

export default LandingSLKflowLandingRoute;
